module.exports = {
    "dev.summitdaily.com": {
        Analytics: {
            AWSPinpoint: {
                appId: 'afad7dddd331448e84f9d770625bd94d', // this is Swift DEV app ID in pinpoint, we dont have one for dev or stage sites
                region: 'us-west-2',
                mandatorySignIn: false
            }
        },
        Auth: {
            identityPoolId: 'us-west-2:7353b930-6d4b-4d5e-82a0-f99144e9e0cb',
            region: 'us-west-2',
            userPoolId: 'us-west-2_i3wjFy9vc',
            clientID: 's12edm6otcvdr0le10aojt4bc',
            userPoolWebClientId: 's12edm6otcvdr0le10aojt4bc',
            mandatorySignIn: false,
            signUpVerificationMethod: 'code', // 'code' | 'link' 
            pubID: 'devsdn',
            pubSecondStreetID: '227', // from secondstreet, using SDN live for dev.sdn
            oauth: {
                domain: 'devsummitdaily.auth.us-west-2.amazoncognito.com',
                scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
                redirectSignIn: 'https://dev.summitdaily.com',
                redirectSignOut: 'https://dev.summitdaily.com',
                responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
            },
        },
        API: {
            endpoints: [
                {
                    name: "sdn",
                    endpoint: "https://567upj39ci.execute-api.us-west-2.amazonaws.com/dev",
                    region: "us-west-2"
                },
            ]
        }
    },
    "stage.summitdaily.com": {
        Analytics: {
            AWSPinpoint: {
                appId: 'afad7dddd331448e84f9d770625bd94d', // this is Swift DEV app ID in pinpoint, we dont have one for dev or stage sites
                region: 'us-west-2',
                mandatorySignIn: false
            }
        },
        Auth: {
            identityPoolId: 'us-west-2:7353b930-6d4b-4d5e-82a0-f99144e9e0cb',
            region: 'us-west-2',
            userPoolId: 'us-west-2_i3wjFy9vc',
            clientID: 's12edm6otcvdr0le10aojt4bc',
            userPoolWebClientId: 's12edm6otcvdr0le10aojt4bc',
            mandatorySignIn: false,
            signUpVerificationMethod: 'code', // 'code' | 'link' 
            pubID: 'devsdn',
            pubSecondStreetID: '227', // from secondstreet, using SDN live for dev.sdn
            oauth: {
                domain: 'devsummitdaily.auth.us-west-2.amazoncognito.com',
                scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
                redirectSignIn: 'https://stage.summitdaily.com',
                redirectSignOut: 'https://stage.summitdaily.com',
                responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
            },
        },
        API: {
            endpoints: [
                {
                    name: "sdn",
                    endpoint: "https://567upj39ci.execute-api.us-west-2.amazonaws.com/dev",
                    region: "us-west-2"
                },
            ]
        }
    },
    "dev.aspentimes.com": {
        Auth: {
            identityPoolId: 'us-west-2:7353b930-6d4b-4d5e-82a0-f99144e9e0cb',
            region: 'us-west-2',
            userPoolId: 'us-west-2_Cyoi5gJzk',
            clientID: '1uae0pleac6j5hcr5ikadfhfhb',
            userPoolWebClientId: '1uae0pleac6j5hcr5ikadfhfhb',
            mandatorySignIn: false,
            signUpVerificationMethod: 'link', // 'code' | 'link' 
            pubID: 'devatd',
            pubSecondStreetID: '435',
            oauth: {
                domain: 'devaspentimes.auth.us-west-2.amazoncognito.com',
                scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
                redirectSignIn: 'https://dev.aspentimes.com',
                redirectSignOut: 'https://dev.aspentimes.com',
                responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
            }
        },
    },
    "stage.aspentimes.com": {
        Auth: {
        identityPoolId: 'us-west-2:0a0abc03-b175-4c95-b363-7220fabdedf9',
        region: 'us-west-2',
            userPoolId: 'us-west-2_rAKc7GBCi',
            clientID: 'hn15278v9fvkn8rlj8ustroto',
            userPoolWebClientId: 'hn15278v9fvkn8rlj8ustroto',
            mandatorySignIn: false,
            signUpVerificationMethod: 'code', // 'code' | 'link'
            pubID: 'atd',
            pubSecondStreetID: '1856',
            oauth: {
                domain: 'login.aspentimes.com',
                scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
                redirectSignIn: 'https://stage.aspentimes.com',
                redirectSignOut: 'https://stage.aspentimes.com',
                responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
            }
        }
    },
    "dev.steamboatpilot.com": {
        Auth: {
            identityPoolId: 'us-west-2:d37cb242-7072-4355-ac23-7124a4c91803',
            region: 'us-west-2',
            userPoolId: 'us-west-2_05Jb7NrPC',
            clientID: '2f3t4s4lgppdc6oo9tfmcjq17q',
            userPoolWebClientId: '2f3t4s4lgppdc6oo9tfmcjq17q',
            mandatorySignIn: false,
            signUpVerificationMethod: 'link', // 'code' | 'link' 
            pubID: 'devsbt',
            pubSecondStreetID: '813',
            oauth: {
                domain: 'https://devsteamboatpilot.auth.us-west-2.amazoncognito.com',
                scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
                redirectSignIn: 'https://dev.steamboatpilot.com',
                redirectSignOut: 'https://dev.steamboatpilot.com',
                responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
            }
        },
    },
    "www.summitdaily.com": {
        Auth: {
            identityPoolId: 'us-west-2:00a80385-30b1-4c2a-96bf-653a5898fd5a',
            region: 'us-west-2',
            userPoolId: 'us-west-2_RHDYAqeFp',
            clientID: '1litubhdrin8vmt96rbfuolmbr',
            userPoolWebClientId: '1litubhdrin8vmt96rbfuolmbr',
            mandatorySignIn: false,
            signUpVerificationMethod: 'link', // 'code' | 'link' 
            pubID: 'sdn',
            pubSecondStreetID: '227',
            oauth: {
                domain: 'login.summitdaily.com',
                scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
                redirectSignIn: 'https://www.summitdaily.com',
                redirectSignOut: 'https://www.summitdaily.com',
                responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
            }
        },
        API: {
            endpoints: [
                {
                    name: "sdn",
                    endpoint: "https://567upj39ci.execute-api.us-west-2.amazonaws.com/prod",
                    region: "us-west-2"
                },
            ]
        }
    },
    "summitdaily.ogdennews.com": {
        Auth: {
            identityPoolId: 'us-west-2:7353b930-6d4b-4d5e-82a0-f99144e9e0cb',
            region: 'us-west-2',
            userPoolId: 'us-west-2_i3wjFy9vc',
            clientID: 's12edm6otcvdr0le10aojt4bc',
            userPoolWebClientId: 's12edm6otcvdr0le10aojt4bc',
            mandatorySignIn: false,
            signUpVerificationMethod: 'code', // 'code' | 'link' 
            pubID: 'devsdn',
            pubSecondStreetID: '227', // from secondstreet, using SDN live for dev.sdn
            oauth: {
                domain: 'devsummitdaily.auth.us-west-2.amazoncognito.com',
                scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
                redirectSignIn: 'https://summitdaily.ogdennews.com',
                redirectSignOut: 'https://summitdaily.ogdennews.com',
                responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
            },
        },
    },
    "aspentimes.ogdennews.com": {
        Auth: {
            identityPoolId: 'us-west-2:7353b930-6d4b-4d5e-82a0-f99144e9e0cb',
            region: 'us-west-2',
            userPoolId: 'us-west-2_Cyoi5gJzk',
            clientID: '1uae0pleac6j5hcr5ikadfhfhb',
            userPoolWebClientId: '1uae0pleac6j5hcr5ikadfhfhb',
            mandatorySignIn: false,
            signUpVerificationMethod: 'link', // 'code' | 'link' 
            pubID: 'devatd',
            pubSecondStreetID: '435',
            oauth: {
                domain: 'devaspentimes.auth.us-west-2.amazoncognito.com',
                scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
                redirectSignIn: 'https://aspentimes.ogdennews.com',
                redirectSignOut: 'https://dev.aspentimes.com',
                responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
            }
        },
    },
    "www.steamboatpilot.com": {
        Auth: {
            identityPoolId: 'us-west-2:4d3a14ce-5d6b-4506-85a9-6ecbc584842a',
            region: 'us-west-2',
            userPoolId: 'us-west-2_dIO5907LE',
            clientID: '7jcs67v3mfgrgctlv4p5rvn2k7',
            userPoolWebClientId: '7jcs67v3mfgrgctlv4p5rvn2k7',
            mandatorySignIn: false,
            signUpVerificationMethod: 'link', // 'code' | 'link' 
            pubID: 'sbt',
            pubSecondStreetID: '813',
            oauth: {
                domain: 'login.steamboatpilot.com',
                scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
                redirectSignIn: 'https://www.steamboatpilot.com',
                redirectSignOut: 'https://www.steamboatpilot.com',
                responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
            }
        }
    },
    "dev.steamboatpilot.com": {
        Auth: {
            identityPoolId: 'us-west-2:7b42b11d-775c-4209-b22d-5475f48e609f',
            region: 'us-west-2',
            userPoolId: 'us-west-2_05Jb7NrPC',
            clientID: '2f3t4s4lgppdc6oo9tfmcjq17q',
            userPoolWebClientId: '2f3t4s4lgppdc6oo9tfmcjq17q',
            mandatorySignIn: false,
            signUpVerificationMethod: 'link', // 'code' | 'link' 
            pubID: 'devsbt',
            pubSecondStreetID: '813',
            oauth: {
                domain: 'login.steamboatpilot.com',
                scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
                redirectSignIn: 'https://dev.steamboatpilot.com',
                redirectSignOut: 'https://dev.steamboatpilot.com',
                responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
            }
        }
    },
    "steamboatpilot.local": {
        Auth: {
            identityPoolId: 'us-west-2:7b42b11d-775c-4209-b22d-5475f48e609f',
            region: 'us-west-2',
            userPoolId: 'us-west-2_05Jb7NrPC',
            clientID: '2f3t4s4lgppdc6oo9tfmcjq17q',
            userPoolWebClientId: '2f3t4s4lgppdc6oo9tfmcjq17q',
            mandatorySignIn: false,
            signUpVerificationMethod: 'link', // 'code' | 'link' 
            pubID: 'devsbt',
            pubSecondStreetID: '813',
            oauth: {
                domain: 'devsteamboatpilot.auth.us-west-2.amazoncognito.com',
                scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
                redirectSignIn: 'https://steamboatpilot.local',
                redirectSignOut: 'https://steamboatpilot.local',
                responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
            }
        }
    },
    "summitdaily.local": {
        Analytics: {
            AWSPinpoint: {
                appId: 'afad7dddd331448e84f9d770625bd94d', // this is Swift DEV app ID in pinpoint, we dont have one for dev or stage sites
                region: 'us-west-2',
                mandatorySignIn: false
            }
        },
        Auth: {
            identityPoolId: 'us-west-2:7353b930-6d4b-4d5e-82a0-f99144e9e0cb',
            region: 'us-west-2',
            userPoolId: 'us-west-2_i3wjFy9vc',
            clientID: 's12edm6otcvdr0le10aojt4bc',
            userPoolWebClientId: 's12edm6otcvdr0le10aojt4bc',
            mandatorySignIn: false,
            signUpVerificationMethod: 'code', // 'code' | 'link' 
            pubID: 'devsdn',
            pubSecondStreetID: '227', // from secondstreet, using SDN live for dev.sdn
            oauth: {
                domain: 'devsummitdaily.auth.us-west-2.amazoncognito.com',
                scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
                redirectSignIn: 'https://summitdaily.local',
                redirectSignOut: 'https://summitdaily.local',
                responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
            },
        },
        API: {
            endpoints: [
                {
                    name: "sdn",
                    endpoint: "https://567upj39ci.execute-api.us-west-2.amazonaws.com/dev",
                    region: "us-west-2"
                },
            ]
        }
    },
    "www.aspentimes.com": {
        Auth: {
        identityPoolId: 'us-west-2:0a0abc03-b175-4c95-b363-7220fabdedf9',
        region: 'us-west-2',
            userPoolId: 'us-west-2_rAKc7GBCi',
            clientID: 'hn15278v9fvkn8rlj8ustroto',
            userPoolWebClientId: 'hn15278v9fvkn8rlj8ustroto',
            mandatorySignIn: false,
            signUpVerificationMethod: 'code', // 'code' | 'link'
            pubID: 'atd',
            pubSecondStreetID: '435',
            oauth: {
                domain: 'login.aspentimes.com',
                scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
                redirectSignIn: 'https://www.aspentimes.com',
                redirectSignOut: 'https://www.aspentimes.com',
                responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
            }
        }
    },
    "www.skyhinews.com": {
        Auth: {
            identityPoolId: 'us-west-2:5e895562-6e4a-4e89-9a7e-56c1d9e2cae7',
            region: 'us-west-2',
            userPoolId: 'us-west-2_Xhd3OXoJF',
            clientID: '3ag5ldpsa4ltotsf824ftlurg8',
            userPoolWebClientId: '3ag5ldpsa4ltotsf824ftlurg8',
            mandatorySignIn: false,
            signUpVerificationMethod: 'code', // 'code' | 'link'
            pubID: 'shn',
            pubSecondStreetID: '1856',
            oauth: {
                domain: 'login.skyhinews.com',
                scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
                redirectSignIn: 'https://www.skyhinews.com',
                redirectSignOut: 'https://www.skyhinews.com',
                responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
            }
        }
    },
    "www.craigdailypress.com": {
        Auth: {
            identityPoolId: 'us-west-2:9236ac4e-62b4-4fc3-a019-8cdfd9b39b84',
            region: 'us-west-2',
            userPoolId: 'us-west-2_FJGN4bSMn',
            clientID: '7rt98quics3e78vsh6btf1c0u0',
            userPoolWebClientId: '7rt98quics3e78vsh6btf1c0u0',
            mandatorySignIn: false,
            signUpVerificationMethod: 'code', // 'code' | 'link'
            pubID: 'cdp',
            pubSecondStreetID: '669',
            oauth: {
                domain: 'login.craigdailypress.com',
                scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
                redirectSignIn: 'https://www.craigdailypress.com',
                redirectSignOut: 'https://www.craigdailypress.com',
                responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
            }
        }
    },
    "www.vaildaily.com": {
        Auth: {
            identityPoolId: 'us-west-2:397540c2-31f3-4b5e-97a8-c45a48b8087f',
            region: 'us-west-2',
            userPoolId: 'us-west-2_tjJ5TCYep',
            clientID: '5m38ck5hep21ron5dv98ce0ife',
            userPoolWebClientId: '5m38ck5hep21ron5dv98ce0ife',
            mandatorySignIn: false,
            signUpVerificationMethod: 'code', // 'code' | 'link'
            pubID: 'vdn',
            pubSecondStreetID: '245',
            oauth: {
                domain: 'login.vaildaily.com',
                scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
                redirectSignIn: 'https://www.vaildaily.com',
                redirectSignOut: 'https://www.vaildaily.com',
                responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
            }
        }
    },
    "www.postindependent.com": {
        Auth: {
            identityPoolId: 'us-west-2:da7a75eb-1281-4e82-a175-710e1a54662d',
            region: 'us-west-2',
            userPoolId: 'us-west-2_X7sE9syP2',
            clientID: '58ujl7e556ujn67frn88jhghs1',
            userPoolWebClientId: '58ujl7e556ujn67frn88jhghs1',
            mandatorySignIn: false,
            signUpVerificationMethod: 'code', // 'code' | 'link'
            pubID: 'gsp',
            pubSecondStreetID: '891',
            oauth: {
                domain: 'login.postindependent.com',
                scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
                redirectSignIn: 'https://www.postindependent.com',
                redirectSignOut: 'https://www.postindependent.com',
                responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
            }
        }
    },
    "www.tahoedailytribune.com": {
        Auth: {
            identityPoolId: 'us-west-2:997d347d-cadd-449f-832a-ca722afdcd05',
            region: 'us-west-2',
            userPoolId: 'us-west-2_CAkChvTkO',
            clientID: '4c89r93a8rqe50r310s953grvb',
            userPoolWebClientId: '4c89r93a8rqe50r310s953grvb',
            mandatorySignIn: false,
            signUpVerificationMethod: 'code', // 'code' | 'link'
            pubID: 'tdt',
            pubSecondStreetID: '1963',
            oauth: {
                domain: 'login.tahoedailytribune.com',
                scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
                redirectSignIn: 'https://www.tahoedailytribune.com',
                redirectSignOut: 'https://www.tahoedailytribune.com',
                responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
            }
        }
    },
    "www.sierrasun.com": {
        Auth: {
            identityPoolId: 'us-west-2:8c91c9a1-4dcd-4719-b9e8-af3738df7a93',
            region: 'us-west-2',
            userPoolId: 'us-west-2_oIJStB045',
            clientID: '43if4d3p2nsq1te9mvqbg3hplg',
            userPoolWebClientId: '43if4d3p2nsq1te9mvqbg3hplg',
            mandatorySignIn: false,
            signUpVerificationMethod: 'code', // 'code' | 'link'
            pubID: 'ssu',
            pubSecondStreetID: '1912',
            oauth: {
                domain: 'login.sierrasun.com',
                scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
                redirectSignIn: 'https://www.sierrasun.com',
                redirectSignOut: 'https://www.sierrasun.com',
                responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
            }
        }
    },
};
// list all domains, check if the current URL is in the list, if so then use that config object
// www.summitdaily.com
// www.aspentimes.com
// www.postindependent.com
// www.vaildaily.com
// www.steamboatpilot.com
// www.skyhinews.com
// www.craigdailypress.com
// www.parkrecord.com
// www.thefencepost.com
// www.tsln.com
// www.tahoedailytribune.com
// www.sierrasun.com

// dev.summitdaily.com
// dev.aspentimes.com
// dev.postindependent.com
// dev.vaildaily.com
// dev.steamboatpilot.com
// dev.skyhinews.com
// dev.craigdailypress.com
// dev.parkrecord.com
// dev.thefencepost.com
// dev.tsln.com
// dev.tahoedailytribune.com
// dev.sierrasun.com

// summitdaily.local
// steamboatpilot.local
// aspentimes.local



// SecondStreet org IDs for each pub
// TPR 1561868 - done
// GSPI 891 - done
// SSU 1912 -  done
// SHN 1856 - done
// SBT 813 - done
// SDN 227 done
// TDT 1963 - done
// ATD 435 - done
// VDN 245 - done
// CDP 669 - done
// TSLN 1576083 - done 
// TFP 1561870 - done

